import React from "react"
import {
  compose,
  shouldUpdate,
  defaultProps,
  withPropsOnChange,
  mapProps,
} from "recompact"
import pick from "ramda/es/pick"
import Timeline, {
  TimelineMarkers,
  TodayMarker,
} from "src/components/CustomReactCalendarTimeline"
import containerResizeDetector from "src/components/CustomReactCalendarTimeline/resize-detector/container"

import "src/components/CustomReactCalendarTimeline/lib/Timeline.scss"
import autoStickyOffset from "./hocs/autoStickyOffset"

// Какие пропы из существующих передать в библиотечный календарь.
// Нужно для лучшего понимания что происходит.
const propsToPass = [
  `items`,
  `headerLabelHeight`,
  `sidebarContent`,
  `itemRenderer`,
  `defaultTimeStart`,
  `defaultTimeEnd`,
  `visibleTimeStart`,
  `visibleTimeEnd`,
  `onTimeChange`,
  `maxZoom`,
  `minZoom`,
  `timeSteps`,
  `onRowMouseDown`,
  `onCanvasMouseMove`,
  `sidebarWidth`,
  `lineHeight`,
  `itemHeightRatio`,
  `rightSidebarWidth`,
  `stickyHeader`,
  `stackItems`,
  `useLayers`,
  `canMove`,
  `dragSnap`,
  `headerLabelGroupHeight`,
  `itemTouchSendsClick`,
  `replacementHeightTop`,
  `replacementHeightBottom`,
  `groups`,
  `groupRenderer`,
  `onItemDeselect`,
  `onItemSelect`,
  `planStart`,
  `planEnd`,
  `resizeDetector`,
  `children`,
  `stickyOffset`,
  `hoverIndex`,
  `setHoverIndex`,
]

/* This code you may need to watch changes in shouldUpdate, don't delete it
while calendar performance is under development */
// import pick from 'lodash/pick'
// import transform from 'lodash/transform'
// import isEqual from 'lodash/isEqual'
// import isObject from 'lodash/isObject'
//
// function difference(object, base) {
//   function changes(object, base) {
//     return transform(object, (result, value, key) => {
//       if (!isEqual(value, base[key])) {
//         result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value
//       }
//     })
//   }
//   return changes(object, base)
// }
//
// const AFFECTED_KEYS = [
//   `groups`,
//   `items`,
//   `visibleTimeStart`,
//   `visibleTimeEnd`,
//   `onTimeChange`,
//   `minZoom`,
//   `maxZoom`,
// ]

const emptyGroupsFix = [
  {
    id: 0,
    title: ``,
    layers: 1,
  },
]

export default compose(
  defaultProps({
    /* https://github.com/namespace-ee/react-calendar-timeline/issues/356 */
    resizeDetector: containerResizeDetector,
    groups: emptyGroupsFix,
    children: (
      <TimelineMarkers>
        <TodayMarker>
          {({ styles }) => {
            const customStyles = {
              ...styles,
              backgroundColor: `rgba(0, 106, 255, 0.6)`,
              zIndex: `89`,
            }
            return <div style={customStyles} />
          }}
        </TodayMarker>
      </TimelineMarkers>
    ),
  }),

  autoStickyOffset,

  /* This hoc should prevent surplus render, that is very important for the
  /* smoothness of its scrolling when dynamic data loading is active */
  shouldUpdate(
    (props, nextProps) =>
      props.groups.length !== nextProps.groups.length ||
      props.items !== nextProps.items ||
      props.visibleTimeStart !== nextProps.visibleTimeStart ||
      props.visibleTimeEnd !== nextProps.visibleTimeEnd ||
      props.onTimeChange !== nextProps.onTimeChange ||
      props.minZoom !== nextProps.minZoom ||
      props.maxZoom !== nextProps.maxZoom,
  ),
  withPropsOnChange([`groups`], ({ groups }) => {
    if (groups.length === 0) {
      /* https://github.com/namespace-ee/react-calendar-timeline/issues/356 */
      return {
        groups: emptyGroupsFix,
      }
    }

    return undefined
  }),
  mapProps(pick(propsToPass)),
)(Timeline)
